<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		selected?: boolean;
		isTransparent?: boolean;
		disabled?: boolean;
		children?: Snippet;
		onclick?: () => void;
	}

	const {
		selected = false,
		isTransparent = false,
		disabled = false,
		children,
		onclick,
	}: Props = $props();
</script>

<button
	class={[
		'flex flex-col gap-2 min-h-26 rd-2 p-4 text-left items-center justify-center',
		disabled ? 'cursor-not-allowed' : 'cursor-pointer',
		{
			'bg-neutral-weak text-coloredneutral border-solid border-0.5 border-neutral shadow-smooth-bottom-2': selected,
			'bg-transparent text-coloredneutral-soft border-dashed border-1.5 border-coloredneutral-weak': !selected && isTransparent,
			'bg-neutral-weakest text-coloredneutral border-solid border-0.5 border-neutral-soft': !selected && !isTransparent,
		},
	]}
	{disabled}
	{onclick}
>
	{@render children?.()}
</button>
